import { z } from 'zod';
import {
  LayoutMode, AvatarShape, FontFamily, FontSize, BorderRadius,
  SelectorKind, PriorityEntity, BlockType
} from '../catalogs/pageCatalog.generated.js';

const seoSchema = z.object({
  title: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
  ogImageUrl: z.string().nullable().optional(),
});

const identitySchema = z.object({
  avatarUrl: z.string().nullable().optional(),
  avatarShape: z.nativeEnum(AvatarShape).default(AvatarShape.Round),
});

const customStylesSchema = z.object({
  primaryColor: z.string().nullable().optional(),
  backgroundColor: z.string().nullable().optional(),
  textColor: z.string().nullable().optional(),
  accentColor: z.string().nullable().optional(),
  buttonBackground: z.string().nullable().optional(),
  fontFamily: z.nativeEnum(FontFamily).default(FontFamily.Inter),
  fontSize: z.nativeEnum(FontSize).default(FontSize.Medium),
  borderRadius: z.nativeEnum(BorderRadius).default(BorderRadius.Soft),
});

const scopeSchema = z.object({
  professionalId: z.string().uuid().nullable().optional(),
  placeId: z.string().uuid().nullable().optional(),
});

const blockSchema = z.object({
  id: z.string().uuid(),
  type: z.nativeEnum(BlockType),
  enabled: z.boolean().default(true),
  order: z.number().int().nonnegative(),
  config: z.record(z.string(), z.unknown()).optional().default({}),
});

export const siteFormSchema = z.object({
  schemaVersion: z.literal(3).optional().default(3),
  layoutMode: z.nativeEnum(LayoutMode).default(LayoutMode.Continuous),
  seo: seoSchema.optional().default({}),
  identity: identitySchema.optional().default({}),
  customStyles: customStylesSchema.optional().default({}),
  scope: scopeSchema.optional().default({}),
  blocks: z.array(blockSchema).optional().default([]),
});

export default siteFormSchema;
